import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  min-height: 0;
`;

export const MainArea = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  min-height: 0;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Body = styled.div<{ isHidden?: boolean }>`
  min-width: 300px;
  flex: 40%;
  border-right: 1px solid ${(props) => props.theme.common.borderColor};
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  min-height: 0;
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    min-width: 0;
    width: 100%;
    border-right: none;
    height: 100dvh;
    position: absolute;
    inset: 0;
    z-index: 2;
    overflow: hidden;

    ${(props) =>
      props.isHidden &&
      css`
        display: none;
      `}
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0.05;
  z-index: 0;
  background: url("/assets/images/bg-chat-room.png") ${(props) => props.theme.chatRoom.bg};
  pointer-events: none;
`;

export const FooterContainer = styled.div`
  background: ${(props) => props.theme.common.primaryColor};
  position: relative;
  z-index: 100;
  flex-shrink: 0;
  padding-bottom: env(safe-area-inset-bottom);
`;

export const ScrollButton = styled.button`
  position: absolute;
  right: 15px;
  bottom: 80px;
  width: 42px;
  height: 42px;
  z-index: -1;
  border-radius: 50%;
  color: ${(props) => props.theme.common.subHeadingColor};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.common.secondaryColor};
  box-shadow: ${(props) => props.theme.chatRoom.scrollBtnBoxShadow};
  z-index: 10;
`;
